import { LmsSentry } from 'react-common'

export const captureException = (error: any) => {
  console.warn(error)
  LmsSentry.captureException(error)
}
